import { ListItem, ListItemText } from "@mui/material"
import Skeleton from "@mui/material/Skeleton"
import { styled } from "@mui/material/styles"
import LoadingTypography from "components/skeleton/LoadingTypography"
import { StyledCustomListItemIcon, StyledDrawerList } from "shared/styled/General"
import { VehicleLoadingItem } from "./VehicleLoadingItem"

const StyledHeadingListItem = styled(ListItem)(({ theme }) => ({
  display: "flex",
  width: "100%",
  maxWidth: 360,
  backgroundColor: theme.palette.background.paper,
  padding: "0 0 1rem 0"
}))

const VehicleLoadingform = () => {
  const numberOfSkeletonItems = [1, 2, 3, 4, 5, 6, 7]

  return (
    <StyledDrawerList sx={{ p: 0 }}>
      <StyledHeadingListItem>
        <StyledCustomListItemIcon size={"45px"}>
          <Skeleton animation="wave" variant="circular" width={45} height={45} />
        </StyledCustomListItemIcon>
        <LoadingTypography variant="caption" />
      </StyledHeadingListItem>
      {numberOfSkeletonItems.map((item) => {
        return <VehicleLoadingItem />
      })}
    </StyledDrawerList>
  )
}
export default VehicleLoadingform
